export const fileEnUSTranslations = {
  fileAccepted: "Accepted: {{types}}",
  fileMaxSize: "Up to {{size}}MB",
  fileMaxSizeEach: "Up to {{size}}MB each",
  fileMaxFiles: "Max {{count}} files",
  fileChooseOneHead: "Choose a file",
  fileChooseManyHead: "Choose files",
  fileDragTail: "or drag & drop",
  fileUpload: "Upload",
  fileAnyOne: "Any single file",
  fileAddMany: "Add one or more files",
  fileReplace: "Replace file",
  fileRemove: "Remove {{name}}",
  fileCurrent: "Current file",
  fileUploading: "Uploading… {{percent}}%",
  fileUploadFailed: "Upload failed.",
  fileUploadOffline:
    "Sorry, this file could not be uploaded because the connection was lost. Check your connection and try again.",
  fileErrorMaxOne: "Maximum 1 file allowed.",
  fileErrorMaxMany: "Maximum {{count}} files allowed.",
  fileErrorTooLarge: "“{{name}}” exceeds the {{size}}MB limit.",
  fileErrorType:
    "“{{name}}” is not an accepted file type. Accepted: {{types}}.",
  fileSelected: "Selected {{name}}",
  filesSelected: "Selected {{count}} files",
  fileProgress: "Uploading {{name}}: {{percent}}%",
  fileComplete: "{{name}} uploaded",
  fileFailed: "Upload of {{name}} failed: {{reason}}",
  fileTriggerName: "{{label}}: {{prompt}}",
  fileRemoved: "Removed {{name}}",
};
